export const getUserEmail = state => state.userData.email;

export const getUserBalance = state => state.userData.balance;
